import React, { useState } from 'react';

const ToggleSwitch = ({ setIsOn, isOn }) => {

    return (
        <label className="switch">
            <input type="checkbox" checked={isOn} onChange={() => setIsOn(!isOn)} />
            <span className="slider round"></span>
        </label>
    );
};

export default ToggleSwitch;
